import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function CheckoutButton({ lookupKey, quantity = 1, children, className = "", testId, onError }) {
  const [loading, setLoading] = useState(false);

  const startCheckout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key: lookupKey,
        quantity,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      const msg = formatApiError(e);
      toast.error(msg);
      onError?.(msg);
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={testId}
      onClick={startCheckout}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-2 disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
      {children}
    </button>
  );
}
